import { useState, useEffect } from 'react';

import { Button, Modal, Table, Typography } from "antd";
import _ from 'lodash';

import { ErrorResponse } from 'utils/types';
import notifier from 'utils/notifier';
import { formatDate } from 'utils/helpers';
import { ORGANIZATION_NAME, companyIdOptions } from 'utils/objects';

import ClaimHistoryDetailModal from 'components/Eligibility/MemberEligibilityDetailTables/ClaimHistoryModal/ClaimHistoryDetailModal';

import ClaimHistoryModalProps from './Proptypes';

import styles from './ClaimHistoryModal.module.scss';

const { Title } = Typography;

const ClaimHistoryModal = (props: ClaimHistoryModalProps) => {
  const [claimHistoryDataSource, setClaimHistoryDataSource] = useState<any[]>([]);
  const [isClaimHistoryDetailModalVisible, setIsClaimHistoryDetailModalVisible] = useState(false);
  const [claimHistoryCount, setClaimHistoryCount] = useState(0);
  const [attachmentList, setAttachmentList] = useState<string[]>([]);
  const [claimDetailModalDataSource, setClaimDetailModalDataSource] = useState<any[]>([]);
  const [companyName, setCompanyName] = useState('');
  const claimHistoryColumns = [
    {
      title: "IPA",
      key: "RmiCompanyId",
      dataIndex: "RmiCompanyId",
    },
    {
      title: "Claim Number",
      key: "RmiClaimNo",
      dataIndex: "RmiClaimNo",
      render:(_: number, record: any) => <Button type="link" onClick={() => claimHistoryDetailModal(record.RmiClaimNo, record.RmiCompanyId)}>{record.RmiClaimNo}</Button>
    },
    {
      title: "Billing Provider",
      key: "RmiRevFullName",
      dataIndex: "RmiRevFullName",
    },
    {
      title: "Status",
      key: "RmiStatus",
      dataIndex: "RmiStatus",
    },
    {
      title: "Claim Date",
      key: "RmiClaimDate",
      dataIndex: "RmiClaimDate",
      render: (_: number, record: any) => formatDate(record.RmiClaimDate, 'MM/DD/YYYY')
    },
  ];

  useEffect(() => {
    if (props.isClaimHistoryModalVisible) {
      postHistory();

      const companyInfo = companyIdOptions.find((val: { companyId: string | null; }) => val.companyId === sessionStorage.getItem('ipa'));
      if (companyInfo && companyInfo.name) setCompanyName(companyInfo!.name);
    }
  }, [props.isClaimHistoryModalVisible])

  const claimHistoryDetailModal = (claimNo: string, companyId: string) => {

    props.getEZ(claimNo, companyId)
      .then((data: any) =>{
        setClaimDetailModalDataSource(data);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });

    props.getAttachments(claimNo, companyId)
      .then((data: string[]) =>{
        setAttachmentList(data);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });

    setIsClaimHistoryDetailModalVisible(true);
  }

  const postHistory = () => {
    const postAuthHistoryParams = {
      RmiCompanyId: props.eligibilityMemberInfo.RmiCompanyId,
      RmiEndDate: props.eligibilityMemberInfo.RmiEndDate,
      RmiMemberKeyId: props.eligibilityMemberInfo.RmiMembKeyId,
      RmiStartDate: props.eligibilityMemberInfo.RmiStartDate,
      UserId: sessionStorage.user_id,
      UserRole: sessionStorage.user_role
    }

    return props.postHistory(postAuthHistoryParams)
      .then((response: any[]) => {
        setClaimHistoryCount(response.length);
        setClaimHistoryDataSource(_.orderBy(response, 'RmiClaimDate', 'desc'));
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  const isClaimHistoryDetailModalVisibleHandler = () => {
    setIsClaimHistoryDetailModalVisible(false);
  }

  return (
    <>
      <Modal
        visible={props.isClaimHistoryModalVisible}
        onCancel={props.claimHistoryCancelHandler}
        maskClosable={false}
        width="800px"
        footer={[
          <div className="row pt-2">
            <div className="col-lg-24 col-md-24">
              <p className="float-left pt-2">&copy; {ORGANIZATION_NAME}, Inc., All Rights Reserved</p>
            </div>
          </div>
        ]}
      >
        <div className="container">
          <Title level={4}>
            <div>{companyName}</div>
            <div>Claim History</div>
          </Title>
        </div>
        <div className={styles['claim-heading']}>
          <div className="column">
            <dl>
              <dt>Member Name:</dt>
              <dd>{props.eligibilityMemberInfo.RmiLastName}, {props.eligibilityMemberInfo.RmiFirstName}</dd>
            </dl>
          </div>
          <div className="column">
            <dl>
              <dt>Member ID:</dt>
              <dd>{props.eligibilityMemberInfo.RmiMembId}</dd>
            </dl>
          </div>
          <div className="column">
            <dl>
              <dt>Count:</dt>
              <dd>{claimHistoryCount}</dd>
            </dl>
          </div>
        </div>

        <Table
          columns={claimHistoryColumns}
          dataSource={claimHistoryDataSource}
          pagination={{ position: ["bottomCenter"], hideOnSinglePage: true }}
          loading={props.isPostingHistory}
        />
      </Modal>
      <ClaimHistoryDetailModal
        claimHistoryDetailModal={claimDetailModalDataSource}
        attachmentList={attachmentList}
        isModalVisibleHandler={isClaimHistoryDetailModalVisibleHandler}
        isModalVisible={isClaimHistoryDetailModalVisible}
        isFetchingEZ={props.isFetchingEZ}
      />
    </>
  );
};

export default ClaimHistoryModal;